import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import agent from "../../api/agent";
import { ApiResponse, LoginResponse } from "../../models/ApiResponse";
import { LoginRequest } from "../../models/requestModels/loginRequest";
import { AuthResponse } from "../../models/responseModels/loginResponse";

type InitialState = {
  isLoginLoading: boolean;
  authResponse: AuthResponse | null | undefined;
  errorMessage: string | null;
};

const initialState: InitialState = {
  isLoginLoading: false,
  authResponse: null,
  errorMessage: null,
};

//Actions
export const userLogin = createAsyncThunk<LoginResponse, LoginRequest>(
  "login/authResponse",
  async (LoginRequest: LoginRequest) => {
    const response = await agent.LoginAgent.login(LoginRequest);
    return response;
  }
);

export const refreshToken = createAsyncThunk<LoginResponse>(
  "refreshToken/authResponse",
  async () => {
    const response = await agent.LoginAgent.refreshToken();
    return response;
  }
);

export const userLogout = createAsyncThunk<ApiResponse>("logout", async () => {
  const response = await agent.LoginAgent.logout();
  return response;
});

const loginSlice = createSlice({
  name: "userLoginAuth",
  initialState,
  reducers: {
    changeTheme: (state, action) => {
      if (state.authResponse && state.authResponse.userSettings) {
        state.authResponse.userSettings.themeName = action.payload;
      }
    },
    updateUserTokenToInvalid: (state, action) => {
      if (state.authResponse && state.authResponse.tokenDetails) {
        state.authResponse.tokenDetails.isValidToken = action.payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(userLogin.pending, (state) => {
        state.isLoginLoading = true;
      })
      .addCase(userLogin.fulfilled, (state, action) => {
        state.isLoginLoading = false;
        if (action.payload.isSuccess) {
          state.authResponse = action.payload.data;
        } else {
          state.authResponse = null;
        }
      })
      .addCase(userLogin.rejected, (state, action) => {
        state.isLoginLoading = false;
        state.errorMessage = action.error.message!;
      })
      .addCase(refreshToken.pending, (state) => {
        state.isLoginLoading = true;
      })
      .addCase(refreshToken.fulfilled, (state, action) => {
        state.isLoginLoading = false;
        if (action.payload.isSuccess) {
          state.authResponse = action.payload.data;
        } else {
          state.authResponse = null;
        }
      })
      .addCase(refreshToken.rejected, (state, action) => {
        state.isLoginLoading = false;
        state.authResponse = null;
        state.errorMessage = action.error.message!;
      })
      .addCase(userLogout.pending, (state) => {
        state.isLoginLoading = true;
      })
      .addCase(userLogout.fulfilled, (state, action) => {
        state.isLoginLoading = false;
        if (action.payload.isSuccess) {
          state.authResponse = null;
        }
      })
      .addCase(userLogout.rejected, (state, action) => {
        state.isLoginLoading = false;
        state.authResponse = null;
        state.errorMessage = action.error.message!;
      });
  },
});

export default loginSlice.reducer;
export const { changeTheme, updateUserTokenToInvalid } = loginSlice.actions;
